module.exports = __webpack_public_path__ + "static/media/certificate_badge.ca71667b.svg";